import { Filters, StrapiTemplateSearchResult } from '../typings';

/**
 * @function filterTemplates
 * @description filter templates by the selected filters
 * @param templateArr list of templates
 * @param filters object of selected filters
 * @returns filtered templates
 */
export function filterTemplates(templateArr: StrapiTemplateSearchResult[], filters: Filters) {
  let filteredTemplateArr = templateArr;
  if (filters.language.length > 0) {
    filteredTemplateArr = filteredTemplateArr.filter(
      (template) => template.template_language && filters.language.includes(template.template_language.name)
    );
  }
  if (filters.categories.length > 0) {
    filteredTemplateArr = filteredTemplateArr.filter((template) => {
      if (!template.categories) return false;
      return template.categories.some((category) => filters.categories.includes(category.name));
    });
  }
  if (filters.trades.length > 0) {
    filteredTemplateArr = filteredTemplateArr.filter((template) => {
      if (!template.trades) return false;
      return template.trades.some((trade) => filters.trades.includes(trade.name));
    });
  }

  return filteredTemplateArr;
}
